module.exports = __webpack_public_path__ + "img/banner-background.16fe3478.png";